import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const JoinPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [tracked, setTracked] = useState(false);

  useEffect(() => {
    const ref = searchParams.get('ref');
    const utm_source = searchParams.get('utm_source') || 'direct';

    if (ref) {
      // Store referral code in localStorage (30-day cookie equivalent)
      localStorage.setItem('referral_code', ref);
      localStorage.setItem('referral_expiry', Date.now() + 30 * 24 * 60 * 60 * 1000);
      localStorage.setItem('referral_source', utm_source);

      // Track the click
      axios.get(`${API_URL}/referral/track`, { params: { ref, utm_source } })
        .then(() => setTracked(true))
        .catch(() => setTracked(true)); // Still redirect even if tracking fails
    } else {
      setTracked(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (tracked) {
      // Redirect to registration page after tracking
      navigate('/auth?signup=true&ref=' + (searchParams.get('ref') || ''));
    }
  }, [tracked, navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A2342]">
      <div className="text-center text-white">
        <div className="animate-spin w-8 h-8 border-2 border-white border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-lg">Setting up your referral...</p>
      </div>
    </div>
  );
};

export default JoinPage;
